import styled from 'styled-components';
import { RouterLink } from '@redux-first-router-link';

export const Container = styled('div')`
  padding-top: ${({ theme }) => theme.x2spacePx}px;
  padding-bottom: ${({ theme }) => theme.x2spacePx}px;
`;

export const Link = styled(RouterLink)`
  ${({ theme }) => theme.typography.small}
`;
